import { DynamicComponentList } from "lib/dynamicComponentList";
import { BaseContent, PageContent } from "types/graphql/generated";

function getDynamicComponentsContent({
  pageComponents,
  baseContent,
  dynamicComponentList,
  statePlans,
}: {
  pageComponents: any[];
  baseContent: BaseContent;
  dynamicComponentList: DynamicComponentList;
  statePlans?: PageContent["statePlans"];
}) {
  const getComponentName = (typename: string) => {
    const component = Object.entries(dynamicComponentList).find((dynamicComponent) => {
      return typename.toLowerCase().split("wd")[0].endsWith(dynamicComponent[0].toLowerCase());
    });

    if (component) {
      return component[0];
    }
  };

  const baseContentWithTransformedKeys: { [key: string]: Object | undefined } = {};

  // eslint-disable-next-line guard-for-in
  for (let key in baseContent) {
    baseContentWithTransformedKeys[key.toLowerCase()] = baseContent[key as keyof BaseContent];
  }

  const dynamicComponentsContentList = pageComponents.map((pageComponent) => {
    if (pageComponent.__typename.toLocaleLowerCase().endsWith("wd")) {
      const key = getComponentName(pageComponent.__typename)?.toLowerCase();

      if (pageComponent.__typename === "ComponentStatePlanInfoStatePlanInfoWd") {
        return (
          key && {
            ...baseContentWithTransformedKeys[key],
            statePlans,
          }
        );
      }

      return key && baseContentWithTransformedKeys[key];
    } else {
      if (pageComponent.__typename === "ComponentStatePlanInfoStatePlanInfo") {
        return { ...pageComponent, statePlans };
      }

      return pageComponent;
    }
  });

  return dynamicComponentsContentList.filter((component) => !!component);
}

export { getDynamicComponentsContent };
